import { css } from "@emotion/react";
import { InputMentionValue } from "@src/types/intelligence-search";
import { MentionsInput, MentionsInputProps } from "react-mentions";

export const InputMention: React.FC<
  MentionsInputProps & {
    value?: InputMentionValue;
    onAfterChange?: (value: InputMentionValue) => void;
    onChange?: (value: InputMentionValue) => void;
    status?: "error" | "warning" | "";
  }
> = ({ value, onChange, onAfterChange, status, ...props }) => {
  return (
    <div
      css={css`
        .mentions {
          border: 1px solid #d9d9d9;
          border-radius: 6px;
          padding: 8px 12px;
          font-size: 14px;
          line-height: 1.5;
          min-height: 80px;
          resize: vertical;
          transition: all 0.2s;

          &:focus {
            border-color: #1890ff;
            box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
            outline: none;
          }

          &:hover {
            border-color: #40a9ff;
          }
        }
        .mentions__suggestions {
          top: 18px !important;
        }
        .mentions.mentions-error {
          border-color: #ff4d4f;

          &:focus {
            border-color: #ff4d4f;
            box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
            outline: none;
          }

          &:hover {
            border-color: #ff7875;
          }
        }

        .mentions.mentions-warning {
          border-color: #faad14;

          &:focus {
            border-color: #faad14;
            box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
            outline: none;
          }

          &:hover {
            border-color: #ffc53d;
          }
        }

        .mentions__control {
          background: white;
          textarea {
            margin: 10px 10px !important;
            width: 96% !important;
          }
        }

        .mentions__input {
          border: none !important;
          outline: none !important;
          padding: 0 !important;
          margin: 0 !important;
        }

        .mentions__suggestions__list {
          border: 1px solid #d9d9d9;
          border-radius: 6px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          max-height: 200px;
          overflow-y: auto;
          background: white;
        }
      `}
    >
      <MentionsInput
        className={`mentions ${status === "error" ? "mentions-error" : ""} ${
          status === "warning" ? "mentions-warning" : ""
        }`}
        allowSpaceInQuery={true}
        value={value?.newValue}
        onChange={(event, newValue, newPlainTextValue, mentions) => {
          const newFieldValue: InputMentionValue = {
            newValue,
            newPlainTextValue,
            mentions,
          };
          onChange?.(newFieldValue);
          onAfterChange?.(newFieldValue);
        }}
        {...props}
      />
    </div>
  );
};
